module.exports = __webpack_public_path__ + "static/media/190-Desktop-Banner@1x.1f4da026.jpg";